import { alertVariants } from "@visiblethread/react-components";

import localhost from "../../../apis/localhost";
import { showErrorModal } from "../../app/actions/error";
import {
  addToJobQueue,
  removeFromJobQueue,
  showGlobalAlert,
} from "../../app/appSlice";
import {
  setEdits,
  setIsSharepointEnabled,
  updateSharepointSettings,
} from "../sharepointSlice";
import { CONNETION_FAILED } from "./constants";

export const saveSharepointSettings = ({ settings, isCloudMode }) => {
  const {
    sharepointUrl,
    sharepointEnabled,
    clientId,
    tenantId,
    clientSecret,
    siteUrl,
  } = settings;
  const params = {
    sharepointUrl,
    sharepointEnabled,
    clientId,
    tenantId,
    clientSecret,
    siteUrl,
  };

  const url = isCloudMode ? "/sharepoint/cloud/save" : "/sharepoint/save";

  return async (dispatch) => {
    dispatch(addToJobQueue("saveSharepointSettings"));
    try {
      const { data } = await localhost.post(url, params);
      dispatch(updateSharepointSettings({ ...settings, id: data.id }));
      dispatch(setEdits({}));
      dispatch(setIsSharepointEnabled(true));
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: "Settings saved successfully",
        })
      );
      return true;
    } catch (error) {
      const { response } = error;
      const errorMessage =
        response?.data.detail || "Please check your settings.";
      dispatch(showErrorModal({ message: errorMessage }, CONNETION_FAILED));
      return false;
    } finally {
      dispatch(removeFromJobQueue("saveSharepointSettings"));
    }
  };
};
